import type { Category } from './types';

export const categories: Category[] = [
  {
    id: 'cat-1',
    slug: 'self-identity',
    name: '情感自我认同',
    description: '探索内心世界，理解并接纳真实的情感需求，建立健康的自我认同感。',
    icon: 'ri-heart-pulse-line',
    articleCount: 5,
  },
  {
    id: 'cat-2',
    slug: 'intimate-communication',
    name: '亲密关系沟通',
    description: '学习在亲密关系中有效表达情感，建立深度连接与理解。',
    icon: 'ri-chat-heart-line',
    articleCount: 4,
  },
  {
    id: 'cat-3',
    slug: 'emotional-confusion',
    name: '情感表达困惑',
    description: '当"不喜欢色色的我吗"成为心声，我们如何面对情感表达中的困惑和不安。',
    icon: 'ri-emotion-line',
    articleCount: 3,
  },
  {
    id: 'cat-4',
    slug: 'self-acceptance',
    name: '自我接纳方法',
    description: '实用的自我接纳技巧与方法，帮助你在情感关系中找到真正的自己。',
    icon: 'ri-mental-health-line',
    articleCount: 4,
  },
  {
    id: 'cat-5',
    slug: 'couple-skills',
    name: '情侣沟通技巧',
    description: '掌握有效的情侣沟通方法，化解矛盾，增进彼此理解与信任。',
    icon: 'ri-user-heart-line',
    articleCount: 3,
  },
  {
    id: 'cat-6',
    slug: 'emotional-needs',
    name: '情感需求理解',
    description: '深入理解自己和他人的情感需求，构建更加和谐的亲密关系。',
    icon: 'ri-empathize-line',
    articleCount: 3,
  },
];